// import 'ant-design-vue/dist/antd.css';
import {App as VueApp, createApp} from 'vue';
import './assets/styles.less';
import App from './components/app/App.vue';
import {RoutesService} from './components/app/routes.service';
import testId from './components/common/test-id.directive';
import './core/dayjs';
import {useService} from './core/useService';
import preCheck from './pre-check';
import {useSentry} from './services/common/sentry.service';
import {createPinia} from 'pinia';
import {useJam} from './services/common/jam.service';
preCheck().then(() => {
    const routesService: RoutesService = useService(RoutesService);
    const app: VueApp = createApp(App);
    app.directive('testId', testId as any);
    app.config.performance = true;
    const router = routesService.getRouter();
    app.use(router);
    useSentry(app, router);
    app.use(createPinia());
    app.mount('#app');
    useJam();
});
